import React from 'react';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Navbar Divider
 * @param children {React.ReactNode} Navbar Divider Children
 * @param className {string} Additionnal css classes
 */
const NavbarDivider = ({ className, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('navbar-divider', className));
    return React.createElement("div", { className: classes, ...others });
};
export default NavbarDivider;
//# sourceMappingURL=NavbarDivider.js.map